import { Component, Output, EventEmitter, OnDestroy, Input } from '@angular/core';
import { GoogleAutocompleteRespData } from 'app/interfaces/google-autocomplete';
import { RequestService } from 'app/shared/services/request.service';
import { Subscription } from 'rxjs';

@Component({
  selector: 'app-google-autocomplete',
  templateUrl: './google-autocomplete.component.html',
  styleUrls: ['./google-autocomplete.component.sass'],
  providers: [ ]
})

export class GoogleAutocompleteComponent implements OnDestroy {

  constructor(
    private requestService: RequestService
  ) { }

  @Output() addressEventData = new EventEmitter<GoogleAutocompleteRespData>();
  @Input() isInput: boolean = false;

  public predictions: any[] = [];
  private prevPredictions: any[] = [];
  private getAutocompleteSubscrition : Subscription = new Subscription();
  public place_id: any;
  public search: string = "";
  public searchValue: string= ""

  async searchAddress(event: Event) {
    this.search = (event.target as HTMLInputElement).value;
    if (this.search.length > 3) {
    this.getAutocompleteSubscrition =  this.requestService.getRequest('place-api/autocomplete/' + this.escapeAddress(this.search), undefined, undefined, false).subscribe(
        (resp) => {
          this.prevPredictions = resp.data.predictions;
          this.predictions = resp.data.predictions;
        }
      )
    }else{
      this.predictions = [];
      this.getAutocompleteSubscrition.unsubscribe();
    }
  }

  exportAddress(address: any) {
    this.requestService.getRequest('place-api/' + address.place_id + '/coordinates', undefined, undefined, false).subscribe(
      (resp) => {

        let cap = "";
        let provincia = "";

        if(resp.data && resp.data.address_components){
          for(let i=0; i < resp.data.address_components.length; i++){
            let info = resp.data.address_components[i];
            if(info.types && info.types.length > 0){
              if(info.types[0] == "postal_code"){
                cap = info.short_name;
              } else if(info.types[0] == "administrative_area_level_2"){
                provincia = info.short_name;
              }
            }
          }
        }

    if(address.terms.length === 3){
          this.addressEventData.emit({
            indirizzo: address.terms[0].value ?? "",
            citta: address.terms[1].value ?? "",
            nazione: address.terms[2].value ?? "",
            latitude: resp.data.geometry.location.lat ?? 0,
            longitude: resp.data.geometry.location.lng ?? 0,
            formatted_address: resp.data.formatted_address,
            place_id: address.place_id ?? "",
            cap: cap,
            provincia: provincia
          })
        }
      else if(address.terms.length === 4){
        this.addressEventData.emit({
          indirizzo: address.terms[0].value ?? "",
          citta: address.terms[1].value ?? "",
          provincia: address.terms[2].value ?? provincia,
          nazione: address.terms[3].value ?? "",
          latitude: resp.data.geometry.location.lat?? 0,
          longitude: resp.data.geometry.location.lng ?? 0,
          formatted_address: resp.data.formatted_address,
          place_id: address.place_id ?? "",
          cap: cap
        });
       }else if(address.terms.length === 5){
        this.addressEventData.emit({
          indirizzo: address.terms[0].value ?? "",
          numero_civico: address.terms[1].value ?? "",
          citta: address.terms[2].value ?? "",
          provincia: address.terms[3].value ?? provincia,
          nazione: address.terms[4].value ?? "",
          latitude: resp.data.geometry.location.lat ?? 0,
          longitude: resp.data.geometry.location.lng ?? 0,
          formatted_address: resp.data.formatted_address,
          place_id: address.place_id ?? "",
          cap: cap
        });
       }else if(address.terms.length >= 6){
        this.addressEventData.emit({
          indirizzo: address.terms[0].value ?? "",
          numero_civico: address.terms[1].value ?? "",
          cap: address.terms[2].value ?? cap,
          citta: address.terms[3].value ?? "",
          provincia: address.terms[4].value ?? provincia,
          nazione: address.terms[5].value ?? "",
          latitude: resp.data.geometry.location.lat ?? 0,
          longitude: resp.data.geometry.location.lng ?? 0,
          formatted_address: resp.data.formatted_address,
          place_id: address.place_id ?? ""
        });
       }
       this.predictions = [];
       this.searchValue= this.isInput ? resp.data.formatted_address: this.searchValue;

 /*        const address_export = { ...address, ...resp.data.result }
        console.log(address_export);
        address_export.cap = address_export.description.split(",")[2].split(" ")[1];
        const regexCap = new RegExp("[0-9]{5}");
        if(!regexCap.test(address_export.cap)){
          address_export.cap = ""
        }
        address_export.longitudine = address_export.geometry.location.lng;
        address_export.latitudine = address_export.geometry.location.lat;
        this.addressEvent.emit(address_export); */

      }
    )
  }

  escapeAddress(address: string) {
    return address.replace("+", "%2B").replace(" ", "%20");
  }
  restoreSearch(){
    this.predictions = this.prevPredictions;
  }
ngOnDestroy(): void {
  this.getAutocompleteSubscrition.unsubscribe();
}
}
